import * as types from 'constants/ActionTypes';
import {
  formatAddress, getNextBuildingId, stripUiAddressFlags, createMapPointFromGeocode,
} from 'features/order/Order.utils';
import { getMapPointsForUpgrade } from 'features/finalizeOrder/FinalizeOrder.utils';

const initState = {
  userEnteredAddress: null,
  geocodedAddress: null,
  mapPoints: [],
  focusedPointIndex: null,
  addressSearchText: '',
  imageCoverageInfo: null,
  imageCoverageInfoLoading: false,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.GEOCODE_SUCCESS: {
      const {
        resetSearchInput,
        userEnteredAddress,
        geocodedAddress,
      } = action;

      return {
        ...state,
        geocodedAddress: stripUiAddressFlags(geocodedAddress),
        mapPoints: [createMapPointFromGeocode(geocodedAddress)],
        userEnteredAddress,
        ...(resetSearchInput && { addressSearchText: formatAddress(geocodedAddress) }),
      };
    }
    case types.CHECK_IMAGE_COVERAGE_RESET: return { ...state, imageCoverageInfo: null };
    case types.CHECK_IMAGE_COVERAGE_START: return { ...state, imageCoverageInfoLoading: true };
    case types.CHECK_IMAGE_COVERAGE_SUCCESS: return { ...state, imageCoverageInfo: action.imageCoverageResult, imageCoverageInfoLoading: false };
    case types.CHECK_IMAGE_COVERAGE_ERROR: return { ...state, imageCoverageInfo: null, imageCoverageInfoLoading: false };
    case types.UPDATE_ADDRESS_SEARCH_TEXT: return { ...state, addressSearchText: action.inputText };
    case types.SET_COUNTRY: return { ...state, ...(action.clearAddressSearch && { addressSearchText: '' }) };
    case types.ADD_MAP_PIN:
      if (!state.geocodedAddress) return state;
      return {
        ...state,
        // #genai - Persist next building ID from existing labels so edited pin numbers are respected
        mapPoints: [...state.mapPoints, createMapPointFromGeocode(action.address, {
          building: getNextBuildingId(state.mapPoints),
          usedZipFallback: false,
        })],
      };
    case types.UPDATE_MAP_POINT_ADDRESS: return {
      ...state,
      mapPoints: state.mapPoints.map(
        (mapPoint, index) => (
          index === action.updateIndex
            ? {
              ...mapPoint,
              address: stripUiAddressFlags({ ...mapPoint.address, ...action.updatedAddress }),
              // #genai - Keep existing building when address-only updates omit it (e.g. reverse geocode)
              building: action.building === undefined ? mapPoint.building : action.building,
              userEditedAddress: mapPoint.userEditedAddress || action.userEditedAddress,
              // usedZipFallback stays on the map point; address edits must not change zoom.
            }
            : mapPoint
        ),
      ),
    };
    case types.UPDATE_MAP_POINT_LOCATION:
      return {
        ...state,
        mapPoints: state.mapPoints.map(
          (mapPoint, index) => (
            index === action.updateIndex
              ? {
                ...mapPoint,
                address: stripUiAddressFlags({ ...mapPoint.address, ...action.newPinLocation }),
                userMovedThePin: true,
                usedZipFallback: false,
              } : mapPoint)
          ,
        ),
      };
    case types.DELETE_MAP_POINT: {
      const mapPoints = state.mapPoints.filter((_, index) => index !== action.deleteIndex);
      return {
        ...state,
        mapPoints,
        focusedPointIndex: null,
        imageCoverageInfoLoading: mapPoints.length > 0 ? state.imageCoverageInfoLoading : false,
        imageCoverageInfo: mapPoints.length > 0 ? state.imageCoverageInfo : null,
      };
    }
    case types.PLACE_ORDER_SUCCESS: return { ...initState, focusedPointIndex: null };
    case types.UPDATE_FOCUSED_POINT: return { ...state, focusedPointIndex: action.focusedPointIndex };
    case types.CANCEL_ORDER_SELECTION: return {
      ...state,
      userEnteredAddress: null,
      geocodedAddress: null,
      mapPoints: [],
      focusedPointIndex: null,
      addressSearchText: '',
    };
    case types.UPGRADE_REPORT_DETAILS_SUCCESS: {
      const upgradeAddresses = getMapPointsForUpgrade(action.upgradeDetails);
      return {
        ...state,
        mapPoints: upgradeAddresses.mapPoints,
        userEnteredAddress: upgradeAddresses.userEnteredAddress,
        geocodedAddress: upgradeAddresses.geocodedAddress,
      }; }
    default: return state;
  }
};
